<template>
  <div :class="`pinwall__grid${mode && mode !== 'search' ? '__' + mode : ''}`">
    <grid-layout
      :layout.sync="posts"
      :col-num="16"
      :row-height="1"
      :is-draggable="editable"
      :is-resizable="editable"
      :is-mirrored="false"
      :vertical-compact="true"
      :margin="[16, 16]"
      :use-css-transforms="true"
    >
      <grid-item
        :class="gridItemClass"
        :id="post.id"
        v-for="post in posts"
        :style="getGridItemStyle(post)"
        :x="post.x"
        :y="post.y"
        @resized="layoutUpdated"
        @moved="layoutUpdated"
        :w="post.w"
        :h="post.h"
        :i="post.i"
        :key="post.id"
      >
        <Post
          @delete="deletePost"
          @editPost="editPost"
          @approvePost="approvePost"
          @fullscreen="fullscreen"
          @filePreview="filePreview"
          @openComments="openComments"
          :post="post"
          :id="post.id"
          :view="'grid'"
          :withComments="withComments"
          :mode="mode"
          @ended="ended"
        ></Post>
      </grid-item>
    </grid-layout>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import VueGridLayout from "vue-grid-layout";
import Post from "./Post";

export default {
  name: "grid",
  props: {
    posts: {
      type: Array
    },
    mode: {
      type: String,
      default: null
    },
    editable: {
      type: Boolean,
      default: true
    },
    withComments: {
      type: Boolean,
      default: true
    }
  },
  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    Post
  },
  data: () => {
    return {
      layout: [],
      firstRender: false
    };
  },
  computed: {
    gridItemClass() {
      return this.isChrome ? "remove-touch" : "";
    }
  },
  methods: {
    ...mapMutations(["setPlayingPost"]),
    layoutUpdated() {
      this.$emit("layoutUpdated");
    },
    deletePost(item) {
      this.$emit("deletePost", item);
    },
    editPost(item) {
      this.$emit("editPost", item);
    },
    approvePost(item) {
      this.$emit("approvePost", item);
    },
    openComments(item) {
      this.$emit("openComments", item);
    },
    fullscreen(item) {
      this.$emit("fullscreen", item);
    },
    filePreview(item) {
      this.$emit("filePreview", item);
    },
    ended() {
      this.$emit("ended");
    },
    getGridItemStyle(post) {
      var style =
        this.mode === "screen" ? "background-color: #000" : post.style;

      if (post.embed && post.embed.type === "twitter") {
        return (
          style +
          `border-top-left-radius: 15px;
    border-top-right-radius: 15px;`
        );
      }

      return style;
    }
  },
  created() {
    this.setPlayingPost(null);
    this.isChrome =
      (!!window.chrome && !!window.chrome.webstore) ||
      navigator.userAgent.toLowerCase().indexOf("android") !== -1 ||
      navigator.userAgent.toLowerCase().indexOf("chrome") !== -1;
  }
};
</script>
